<template>
  <vs-card>
    <div class="vx-row p-5">
      <div class="vx-col w-full px-8">
        <form method="POST" @submit.prevent="save_changes">
          <div class="vx-row">
            <!-- Mantra Title -->
            <div class="vx-col w-1/2 mb-2">
              <vs-input
                class="w-full"
                v-validate="'required|exclude_special_char|min:4'"
                v-model="form.name"
                label="Creator Name *"
                name="name"
                placeholder=" Gurdas Maan"
                data-vv-as="Creator Name"
                id="Creator Name"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
            </div>

            <!-- Meaning -->
            <div class="vx-col w-1/2 mb-2"></div>

            <!-- Day Time -->
            <div class="vx-col w-1/2 mb-2">
              <label class="vs-input--label">Creator Type *</label>
              <select-2
                class="w-full country-input"
                name="type"
                placeholder=" Select Creator Type"
                :value="form.types"
                @input="(item) => (form.types = item && item.value)"
                autocomplete
                :ssr="true"
                :multiple="true"
                v-validate="'required'"
                action="common/getAdminPreDefinedValues"
                :viewRendered="false"
                :options="CreatorTypes"
                data-vv-as="Creator Type"
                :clearable="!!form.types.length"
              />
              <span class="text-danger text-sm" v-show="errors.has(`type`)">{{ errors.first(`type`) }}</span>

              <div class="mt-3">
                <label class="vs-input--label block" for="About">About</label>
                <vs-textarea
                  v-validate="'exclude_special_char'"
                  placeholder="This mantra is a powerful invocation to the Supreme Being, it is commonly recited at the beginning of religious ceremonies and spiritual practices. It signifies the recognition and love of the Divine."
                  class="w-full input mb-0"
                  id="about"
                  name="about"
                  v-model="form.about"
                  :rows="6"
                  data-vv-as="About"
                />
                <span class="text-danger text-sm" v-show="errors.has('about')">{{ errors.first('about') }}</span>
              </div>
            </div>

            <!-- Mantra -->
            <div class="vx-col w-1/2 mb-2">
              <!-- <label class="vs-input--label block" for="Mantra">Mantra *</label>
              <vs-textarea placeholder="Waheguru" class="w-full input mb-0" id="mantra" v-validate="'required'" name="mantra" v-model="form.mantra" :rows="6" data-vv-as="Mantra" />
              <span class="text-danger text-sm" v-show="errors.has('mantra')">{{ errors.first('mantra') }}</span> -->
            </div>

            <!-- Image -->
            <!-- Image -->
            <div class="vx-col w-1/2 cursor-pointer">
              <label class="vs-input--label block">Image *</label>

              <!-- File Input (Removed v-validate and changed name) -->
              <input
                :key="fileKey"
                type="file"
                class="border p-2 rounded w-full"
                ref="files"
                accept=".jpg, .png, .jpeg"
                @change="handleFileUpload"
                style="border: 1px solid rgba(0, 0, 0, 0.2)"
                data-vv-as="Image"
              />

              <!-- Hidden Input for Validation -->
              <input type="hidden" name="image" v-model="form.image" v-validate="imagevalidationRule" data-vv-as="Image" />

              <!-- Display Validation Error -->
              <span class="text-danger text-sm" v-show="errors.has('image')">{{ errors.first('image') }}</span>

              <!-- Preview Image -->
              <div class="mt-5">
                <div class="relative" v-if="preview_image">
                  <div class="h-64 w-64 mt-5 overflow-hidden">
                    <img height="200px" width="250px" :src="preview_image" alt="Image Preview" class="object-fit" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row pt-5 px-5 text-center">
            <div class="vx-col w-full">
              <div class="items-center">
                <vs-button class="mr-2 vs-con-loading__container" id="create-creator" @click="save_changes"> {{ $route.params.id ? 'Update' : 'Add' }}</vs-button>
                <vs-button color="danger" class="text-left" @click="navigateList">Cancel</vs-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <vs-popup title="Image Cropper" name="Image" :active.sync="IsOpenImageCrop" class="image-cropper" style="z-index: 55000">
      <div class="text-center flex justify-center w-full h-full">
        <!-- modal content -->
        <div class="modal__content w-full h-full">
          <!-- modal body -->
          <div class="modal-body w-full h-full">
            <div class="modal-form w-full h-full">
              <div class="w-full h-full max-h-450">
                <cropper ref="cropper" name="Image" class="cropper-image" :src="this.crop_image.src" :aspectRatio="1 / 1" :initialAspectRatio="1 / 1" />
              </div>
              <div class="button-wrapper mt-3">
                <vs-button type="" @click="cropImage()" class="text-primary border border-solid border-primary">Crop Image</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </vs-card>
</template>
<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { mapActions, mapState } from 'vuex'
export default {
  /** Page Name */
  name: 'AddUpdate',

  /** components */
  components: {
    Select2,
    Cropper
  },

  /** data */
  data() {
    return {
      fileKey: 0,
      CreatorTypes: [],
      breadcrumb: [],
      form: {
        title: null,
        types: [],
        about: '',
        image: null
      },
      preview_image: null,
      crop_image: {
        src: '',
        type: '',
        isRound: true
      },
      IsOpenImageCrop: false
    }
  },

  /** computed */
  computed: {
    ...mapState('creator', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    },
    imagevalidationRule() {
      return !this.$route.params.id ? 'required' : ''
    }
  },

  /** created */
  async created() {
    if (this.$route.params.id) {
      await this.$store.dispatch('creator/show', this.$route.params.id).then(async (res) => {
        const data = res.data.data

        /** breadcrumb implement  */
        this.breadcrumb = [
          { title: 'Dashboard', url: '/dashboard' },
          { title: 'Creator', url: '/creator/list' },
          { title: `Edit ${data.name}`, active: true }
        ]

        /* form variable */
        this.form.name = data.name
        this.form.types = data.types
        this.form.about = data.about
        this.preview_image = data.image ? data.image : null
      })
    }
    const { data } = await this.getAdminPreDefinedValues({ type: 'creators' })

    this.CreatorTypes = data.results.map((value) => {
      return {
        value: value._id,
        label: value.title
      }
    })
  },

  /** methods */
  methods: {
    ...mapActions('creator', {
      create: 'create',
      update: 'update'
    }),
    ...mapActions('common', {
      getAdminPreDefinedValues: 'getAdminPreDefinedValues'
    }),
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (!this.$route.params.id && !this.form.image) {
        this.$vs.notify({
          title: 'Error',
          text: 'Image Is Required!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        const data = new FormData()
        for (const key in this.form) {
          if (this.form[key]) {
            if (typeof this.form[key] === 'object' && key != 'image') {
              this.form[key].map((item) => {
                data.append(`${key  }[]`, item)
              })
            } else {
              data.append(key, this.form[key])
            }
          }
        }
        if (this.$route.params.id) {
          response = await this.update({
            id: this.$route.params.id,
            data
          })
        } else {
          response = await this.create(data)
        }
        this.$router.push({
          name: 'creator-list'
        })
        this.$emit('update-data', true)
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    /** navigate to list */
    navigateList() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Cancel`,
        text: `Are you sure you want to cancel?`,
        accept: () => {
          this.$router.push({ name: 'creator-list' })
        },
        acceptText: 'Yes',
        cancelText: 'No'
      })
    },

    /** file upload  */
    handleFileUpload(e) {
      const file = e.target.files[0]

      // Restrict file types
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg']
      if (!allowedTypes.includes(file.type)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Only JPG, PNG, and JPEG images are allowed.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      const blob = URL.createObjectURL(file)
      this.crop_image = {
        src: blob,
        type: file.type
      }
      // e.target.value = ''
      this.IsOpenImageCrop = true

      // Increment fileKey to force re-render
      this.fileKey++
    },
    cropImage() {
      const result = this.$refs.cropper.getResult()
      if (result.canvas == undefined) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please Select Image',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }
      const resultTest = result.canvas.toDataURL(this.crop_image.type)
      const base64Image = resultTest.replace(`data:${this.crop_image.type};base64,`, '')
      this.b64toBlob(base64Image, this.crop_image.type)

      this.IsOpenImageCrop = false
    },
    b64toBlob(b64Data, contentType = '', sliceSize = 512) {
      const byteCharacters = window.atob(b64Data)
      const byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      const blob = new File(byteArrays, 'image.jpg', {
        type: contentType
      })
      this.form.image = blob // Ensure this is set
      this.preview_image = URL.createObjectURL(blob)
      return blob
    }
  },

  /** watch */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-creator',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-creator > .con-vs-loading')
      }
    }
  }
}
</script>
<style>
.cropper-image {
  height: 400px;
  background: #ddd;
}

.vs-button-text.vs-button--text {
  color: #fff !important;
}
</style>
